import { Modal } from "@xola/ui-kit";
import React from "react";
import { SecondaryButton } from "@/components/Common/SecondaryButton";

interface DropErrorModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const DropErrorModal = ({ isOpen, onClose }: DropErrorModalProps) => {
    return (
        <Modal isOpen={isOpen} size="small" onClose={onClose}>
            <Modal.Header>Drop Action Failed</Modal.Header>
            <Modal.Body>
                <p>Collections can&apos;t be nested more than 3 levels deep.</p>
            </Modal.Body>
            <Modal.Footer>
                <SecondaryButton onClick={onClose}>Close</SecondaryButton>
            </Modal.Footer>
        </Modal>
    );
};
